<template>
  <form @submit.prevent="submit">
    <Alert
      v-if="incompatible"
      :message="getIncompatibleMessage()"
      variant="warning"
      :dismissible="false"
    />
    <p>{{ getConfirmationQuestion() }}</p>
    <div class="form-buttons">
      <Btn
        class="mr-2"
        variant="light"
        type="button"
        :disabled="isSubmitting"
        @click="cancel"
        data-test="cancel-confirm-update-php-version-button"
      >
        {{ $t("global.cancel") }}
      </Btn>
      <Btn
        variant="primary"
        type="submit"
        :disabled="!isSubmittable()"
        :loading="isSubmitting"
        data-test="confirm-update-php-version-button"
      >
        {{ $t("global.change-version") }}
      </Btn>
    </div>
  </form>
</template>

<script>
import { reactive, ref } from "@vue/composition-api";
import Alert from "@/components/display/Alert";
import Btn from "@/components/display/Btn";
import store from "@/store";

export default {
  name: "PhpUpdateConfirmForm",
  props: {
    incompatible: {
      type: Boolean,
      default: false,
    },
    resourceName: {
      type: String,
      required: true,
    },
    site: {
      type: Object,
      required: true,
    },
    version: {
      type: String,
      required: true,
    },
  },
  components: {
    Alert,
    Btn,
  },
  setup(props, { emit, root }) {
    const cancel = () => emit("close");
    const isSubmitting = ref(false);
    const fields = reactive({
      checkCompatibility: false,
      version: props.version,
    });

    const getConfirmationQuestion = () =>
      root.$t("global.php-change-version-confirm-message", { version: props.version });
    const getIncompatibleMessage = () =>
      root.$t("global.php-change-version-confirm-incompatibility", { version: props.version });

    const isSubmittable = () => !isSubmitting.value;

    const submit = () => {
      isSubmitting.value = true;
      const { checkCompatibility, version } = fields;
      store
        .dispatch("php/updateVersion", {
          id: props.site.id,
          data: { checkCompatibility, version },
        })
        .then(() => {
          store.dispatch("toasts/addToast", {
            variant: "info",
            message: root.$t("toasts.php-version-updating-message", {
              name: props.resourceName,
              version,
            }),
          });
          emit("close");
        })
        .catch(() => {
          store.dispatch("toasts/addToast", {
            variant: "error",
            message: root.$t("toasts.php-version-update-error-message", {
              name: props.resourceName,
              version,
            }),
          });
        })
        .finally(() => {
          isSubmitting.value = false;
        });
    };

    return {
      cancel,
      getConfirmationQuestion,
      getIncompatibleMessage,
      isSubmittable,
      isSubmitting,
      submit,
    };
  },
};
</script>

<style lang="scss" scoped>
.form-buttons {
  text-align: right;
  padding-top: 2rem;
}
</style>
